import { Position } from 'models';
import { toTimezone } from 'utils/dateTimeUtils';
import Enums from 'utils/EnumsManager';

const { GROUPS_ZONE_TAG_ACTIONS } = Enums.REPORTS;

const actions = GROUPS_ZONE_TAG_ACTIONS.map(action => `__${action}`);

class ReportSummary {
  constructor(params) {
    // validations
    if (!_.isPlainObject(params)) {
      return console.error('TypeError: "params" should be a object!');
    }

    const {
      id,
      reportId,
      name = '',
      position,
      updatedAt,
      groupSettings = null,
      summarySettings = null,
      orderSettings = {
        field_name: null,
        direction: 'desc'
      }
    } = params;

    this.setInitId(id);
    this.reportId = reportId;
    this.name = name;
    // this.updatedAt = toTimezone(updatedAt, true);

    this.position = new Position(position);
    // TODO: still thinking
    // {string} field
    this.groupSettings = this.getGroupSettings(groupSettings);

    // {string} field + func
    this.summarySettings = summarySettings;

    // {object} { field, order }
    this.orderSettings = orderSettings;
  }

  // Get id for new or exist record
  setInitId(val) {
    if (_.isNumber(val)) {
      this.id = val;
      return;
    }
    // TODO: remove later
    this.id = Math.round(Math.random() * 100000);
    // this.id = Date.now();
  }

  getGroupSettings(val) {
    actions.forEach(a => {
      if (_.endsWith(val, a)) {
        val = val.replace(a, '');
      }
    });
    return val;
  }

  isValid() {
    if (_.isEmpty(this.name)) return false;
    if (_.isEmpty(this.groupSettings)) return false;
    if (_.isEmpty(this.summarySettings)) return false;
    if (
      _.isEmpty(this.orderSettings) ||
      _.isEmpty(this.orderSettings.field_name) ||
      _.isEmpty(this.orderSettings.direction)
    ) {
      return false;
    }
    return true;
  }

  toApi() {
    return {
      id: this.id,
      report_id: this.reportId,
      slot_position: {
        x: this.position.x,
        y: this.position.y
      },
      name: this.name,
      setup_properties: {
        // TODO: parse group by for date/datetime field
        group_by: this.groupSettings,
        aggregation: this.summarySettings,
        order_by: this.orderSettings
      }
    };
  }
}

export default ReportSummary;



// WEBPACK FOOTER //
// ./src/models/Dashboards/ReportSummary.js